import { __extends, __rest, __assign } from 'tslib';
import * as React from 'react';
import { UitkField } from 'uitk-react-field';
import { UitkIcon, UitkIconSize } from 'uitk-react-icons';
import { classNames } from 'uitk-react-utils';
import styles from './uitk-input.css';
var getClassNameList = classNames.bind(styles);
var UitkSelect = /** @class */function (_super) {
  __extends(UitkSelect, _super);
  function UitkSelect(props) {
    var _this = _super.call(this, props) || this;
    _this.handleChange = function (event) {
      var _a = _this.props,
        placeholder = _a.placeholder,
        onChange = _a.onChange,
        onBlur = _a.onBlur;
      if (event.type === 'change') {
        _this.handleEmptyState();
        if (onChange) {
          onChange(event);
        }
      } else if (event.type === 'blur' && onBlur) {
        onBlur(event);
      }
      if (placeholder && event.target && event.target.value !== placeholder) {
        event.target.classList.remove('uitk-field-select-placeholder');
      }
    };
    _this.state = {
      emptyStateSelection: false
    };
    _this.handleChange = _this.handleChange.bind(_this);
    return _this;
  }
  UitkSelect.prototype.handleEmptyState = function () {
    var emptyState = this.props.emptyState;
    if (emptyState) {
      this.setState(function () {
        return {
          emptyStateSelection: true
        };
      });
    }
  };
  UitkSelect.prototype.render = function () {
    // Black list these props from the select field
    var _a = this.props,
      className = _a.className,
      domRef = _a.domRef,
      label = _a.label,
      hasBorder = _a.hasBorder,
      hasFloatedLabel = _a.hasFloatedLabel,
      hasVisibleLabel = _a.hasVisibleLabel,
      icon = _a.icon,
      invalid = _a.invalid,
      placeholder = _a.placeholder,
      children = _a.children,
      emptyState = _a.emptyState,
      attributes = __rest(_a, ["className", "domRef", "label", "hasBorder", "hasFloatedLabel", "hasVisibleLabel", "icon", "invalid", "placeholder", "children", "emptyState"]);
    var id = attributes.id,
      disabled = attributes.disabled,
      readOnly = attributes.readOnly,
      value = attributes.value;
    var emptyStateSelection = this.state.emptyStateSelection;
    var baseClass = 'uitk-field-select';
    var defaultValue = emptyState ? '' : placeholder;
    var fieldProps = {
      className: getClassNameList("".concat(baseClass, "-field"), emptyState && !value && !emptyStateSelection && "".concat(baseClass, "-empty-state")),
      disabled: disabled,
      hasBorder: hasBorder,
      hasFloatedLabel: hasFloatedLabel,
      hasVisibleLabel: hasVisibleLabel,
      icon: icon,
      id: id,
      invalid: invalid,
      label: label,
      placeholder: defaultValue,
      readOnly: readOnly,
      required: attributes.required
    };
    var wrapperClassNames = getClassNameList(baseClass, !emptyState && placeholder && "".concat(baseClass, "-placeholder"), className);
    return React.createElement(UitkField, __assign({}, fieldProps), React.createElement("select", __assign({}, attributes, {
      className: wrapperClassNames,
      "aria-describedby": invalid ? "".concat(id, "-error") : undefined,
      ref: domRef,
      defaultValue: defaultValue,
      onChange: this.handleChange,
      onBlur: this.handleChange
    }), (emptyState || placeholder) && React.createElement("option", {
      value: defaultValue,
      disabled: true,
      className: getClassNameList("".concat(baseClass, "-dummy-option")),
      "aria-selected": "false"
    }, defaultValue), children), React.createElement(UitkIcon, {
      name: "expand_more",
      className: getClassNameList("".concat(baseClass, "-icon")),
      size: UitkIconSize.SMALL
    }));
  };
  UitkSelect.displayName = 'UitkSelect';
  UitkSelect.defaultProps = {
    emptyState: false
  };
  return UitkSelect;
}(React.Component);
export { UitkSelect };